"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const getContent_1 = require("../../helpers/getContent");
const getProgressMeasureUpdatedEvent_1 = require("../../helpers/getEvent/getProgressMeasureUpdatedEvent");
const getReviewedEvent_1 = require("../../helpers/getEvent/getReviewedEvent");
const reviewInteraction_1 = require("../../helpers/getInteraction/reviewInteraction");
const getState_1 = require("../../helpers/getState");
const getStateInteraction_1 = require("../../helpers/getStateInteraction");
const setStartedOn_1 = tslib_1.__importDefault(require("../helpers/setStartedOn"));
function getExistingStateInteractionIndex(command, allStateInteractions) {
    try {
        const { reviewedAssignmentQuestionId, receiverId, reviewerId, reviewedSubmissionId } = command;
        const peerReviewStateInteractionIndex = getStateInteraction_1.getPeerReviewStateInteractionOfReviewerOnSubmissionIndex(allStateInteractions, reviewedAssignmentQuestionId, reviewerId, receiverId, reviewedSubmissionId);
        return peerReviewStateInteractionIndex;
    }
    catch (error) {
        throw new Error('Error in getExistingStateInteractionIndex ' + error);
    }
}
function getReviewInteractionParam(command, content, user) {
    return {
        companyId: user.companyId,
        actorType: command.actorType,
        isAnonymous: command.isAnonymous,
        questionId: command.reviewedAssignmentQuestionId,
        reviewedOfId: command.receiverId,
        reviewedSubmissionId: command.reviewedSubmissionId,
        reviewerId: command.reviewerId,
        reviews: command.reviews,
        timeStamp: command.timeStamp,
        rootContentId: content.rootOfferId
    };
}
const getMinReviewCount = (cardQuestionForReviewContent) => {
    return cardQuestionForReviewContent.children[0].minReviewCount;
};
function addReviewGiven(command, content, user, cardQuestionForReviewState) {
    const { contentId, reviewerId } = command;
    const cardQuestionForReviewContent = getContent_1.getContentByContentId(content, contentId);
    const minReviewCount = getMinReviewCount(cardQuestionForReviewContent);
    const reviewsGivenCount = (cardQuestionForReviewState.reviewsGivenCount || 0) + 1;
    const previousProgressMeasure = cardQuestionForReviewState.progressMeasure || 0;
    cardQuestionForReviewState.reviewsGivenCount = reviewsGivenCount;
    cardQuestionForReviewState.progressMeasure = Math.min(minReviewCount, reviewsGivenCount) / minReviewCount;
    const updatedProgressMeasure = cardQuestionForReviewState.progressMeasure || 0;
    const progressUpdatedEvent = getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, user.companyId, reviewerId, contentId, content.offerType, previousProgressMeasure, updatedProgressMeasure);
    return { newEvents: [progressUpdatedEvent] };
}
function updateDates(state, timeStamp) {
    state.lastAccessedOn = timeStamp;
    state.updatedAt = timeStamp;
    setStartedOn_1.default(state, timeStamp);
}
function toUpdatePeerReview(command, stateInteractions) {
    try {
        const existingStateInteractionIndex = getExistingStateInteractionIndex(command, stateInteractions);
        if (existingStateInteractionIndex > -1) {
            const existingStateInteraction = stateInteractions[existingStateInteractionIndex];
            return existingStateInteraction.updatedAt !== command.timeStamp;
        }
        return true;
    }
    catch (error) {
        throw new Error('Error in toUpdatePeerReview ' + error);
    }
}
function updateOrCreatePeeerReviewStateInteraction(command, content, user, allStateInteractions) {
    try {
        const updatedStateInteractions = immer_1.produce(allStateInteractions, draftStateInteractions => {
            const existingStateInteractionIndex = getExistingStateInteractionIndex(command, draftStateInteractions);
            const reviewInteractionParam = getReviewInteractionParam(command, content, user);
            if (existingStateInteractionIndex > -1) {
                const existingStateInteraction = draftStateInteractions[existingStateInteractionIndex];
                reviewInteraction_1.updateReviewInteraction(reviewInteractionParam, existingStateInteraction);
            }
            else {
                const reviewStateInteraction = reviewInteraction_1.createReviewInteraction(reviewInteractionParam);
                draftStateInteractions.push(reviewStateInteraction);
            }
        });
        return updatedStateInteractions;
    }
    catch (error) {
        throw new Error('Error in updateOrCreatePeeerReviewStateInteraction ' + error);
    }
}
function applyPeerReviewGivenCommand(command, content, user, states, stateInteractions) {
    try {
        const { contentId, reviewerId, timeStamp } = command;
        const events = [];
        let updatedStates = states;
        // const stateInteractions: StateInteraction[] = [];
        let updatedStateInteractions = stateInteractions;
        if (toUpdatePeerReview(command, stateInteractions)) {
            updatedStates = immer_1.produce(states, draftStates => {
                const cardQuestionForReviewContent = getContent_1.getContentByContentId(content, contentId);
                const cardQuestionForReviewState = getState_1.getStateByContentIdUserId(draftStates, contentId, reviewerId);
                if (cardQuestionForReviewState) {
                    const { newEvents = [] } = addReviewGiven(command, content, user, cardQuestionForReviewState);
                    events.push(...newEvents);
                    updateDates(cardQuestionForReviewState, timeStamp);
                }
                updatedStateInteractions = updateOrCreatePeeerReviewStateInteraction(command, content, user, stateInteractions);
                const reviewedEvent = getReviewedEvent_1.getReviewedEvent(command, user.companyId, cardQuestionForReviewContent.offerType);
                events.push(reviewedEvent);
            });
        }
        return { states: updatedStates, events, stateInteractions: updatedStateInteractions, enrolments: [] };
    }
    catch (error) {
        throw new Error('Error in applyPeerReviewGivenCommand ' + error);
    }
}
exports.applyPeerReviewGivenCommand = applyPeerReviewGivenCommand;
//# sourceMappingURL=applyPeerReviewGivenCommand.js.map